import { create } from 'zustand';

import { getEmpleados, GetEmpleadosParams } from '@/shared/actions/erp/empleados';
import { ALL_EMPLADO, EmpleadoColor, IEmpladoParams } from '@/shared/interfaces/erp/empleados';
import { useAuthStore } from '@/store/auth';

export interface EmpleadoStore {
  empleado: IEmpladoParams[];
  isLoadingEmpleado: boolean;
  ///* actions
  getEmpleado: (params: GetEmpleadosParams) => void;

  ///* obtener perfil del color
  empladoColor: EmpleadoColor[],
  getEmpleadoColor: (params: GetEmpleadosParams) => void;

  ///* obtener empleado mas filtro VER TODOS
  getEmpleadoByAll: (params: GetEmpleadosParams) => void;

}

export const useEmpleadoStore = create<EmpleadoStore>(set => ({
  empleado: [],
  isLoadingEmpleado: false,
  getEmpleado: async (params) => {
    const user = useAuthStore.getState().user;
    params.canales_venta = user?.canales.join(',') ?? null
    set({ isLoadingEmpleado: true });
    const resp = await getEmpleados(params);
    set({ empleado: resp.data.data });
    set({ isLoadingEmpleado: false });

  },

  empladoColor: [],
  async getEmpleadoColor(params) {
    set({ isLoadingEmpleado: true });
    const resp = await getEmpleados(params);

    const empleados = resp.data.data.map((element) => {
      return {
        username: element.user ?? 'none',
        color: element.profile_data?.color ?? 'none'
      }
    }).filter(e => e.username != 'none')

    set({ empladoColor: empleados });
    set({ isLoadingEmpleado: false });
  },

  async getEmpleadoByAll(params) {
    const user = useAuthStore.getState().user;

    params.canales_venta = user?.canales.join(',') ?? null
    set({ isLoadingEmpleado: true });
    const resp = await getEmpleados(params);

    const empladoFilter = [ALL_EMPLADO, ...resp.data.data]

    set({ empleado: empladoFilter });
    set({ isLoadingEmpleado: false });
  },

}));
